<script setup lang="ts">
import { computed, inject, Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Subjekt } from '/@src/client-portal'
import { formatDateString } from '/@src/utils/format'

const emptyResponse = inject<any>('emptyResponse')
const { t } = useI18n()
const isReadOnly = inject<boolean>('isReadOnly')
const subjektDetail = inject<Ref<Subjekt>>('subjektDetail')

const meno = computed(() =>
  isReadOnly
    ? emptyResponse.ziadatel.osoba.osobaRef.menoUplne
    : subjektDetail?.value?.osoba?.menoUplne
)

const datum = computed(() =>
  isReadOnly
    ? formatDateString(emptyResponse.ziadatel.osoba.osobaRef.datumNarodenia)
    : formatDateString(subjektDetail?.value?.osoba?.datumNarodenia)
)

const email = computed(() =>
  isReadOnly
    ? emptyResponse.ziadatel.osoba.osobaRef.primarnyKontakt.email
    : subjektDetail?.value?.osoba?.primarnyKontakt?.email
)

const telefon = computed(() =>
  isReadOnly
    ? emptyResponse.ziadatel.osoba.osobaRef.primarnyKontakt.telefonneCislo
    : subjektDetail?.value?.osoba?.primarnyKontakt?.telefonneCislo
)
</script>

<template>
  <IDSKHeading as="h2" variant="l">{{
    t('zoppm.step7.fyzickaOsoba.secondHeading')
  }}</IDSKHeading>

  <ValidationWrapper v-slot="slotProps" name="ziadatel">
    <IDSKInput v-bind="slotProps" readonly hidden />
  </ValidationWrapper>

  <DisplayList v-if="!isReadOnly" bold="title" variant="inline" inline-layout="one-half">
    <dt>{{ t('zoppm.step7.fyzickaOsoba.menoAPriezvisko') }}</dt>
    <dd>{{ meno }}</dd>
    <dt v-if="datum">{{ t('zoppm.step7.fyzickaOsoba.datumNarodenia') }}</dt>
    <dd>{{ datum }}</dd>

    <dt v-if="email">{{ t('zoppm.step7.fyzickaOsoba.email') }}</dt>
    <dd>{{ email }}</dd>

    <dt v-if="telefon">{{ t('zoppm.step7.fyzickaOsoba.telefon') }}</dt>
    <dd>{{ telefon }}</dd>
  </DisplayList>
  <DisplayList v-else bold="title" variant="inline" inline-layout="one-half">
    <dt>{{ t('zoppm.step7.fyzickaOsoba.menoAPriezvisko') }}</dt>
    <dd>{{ t('zoppm.step7.fyzickaOsoba.menoAPriezviskoVzorova') }}</dd>

    <dt v-if="datum">{{ t('zoppm.step7.fyzickaOsoba.datumNarodenia') }}</dt>
    <dd>{{ t('zoppm.step7.fyzickaOsoba.datumNarodeniaVzorova') }}</dd>
  </DisplayList>
</template>

<style lang="scss">
.bold {
  font-weight: bold;
}
</style>
